define([], function () {
    "use strict";

    var verifycodeSuccess = require("custom/images/verifycode_success.png");
    var verifycodeFail =  require("custom/images/verifycode_valid.png");
    var validUrl = "/authui/preValidVerifycode";

    function changeToSuccessImg(imgWidget)
    {
        imgWidget.attr("src", verifycodeSuccess);
        imgWidget.show();
    }

    function changeToFailImg(imgWidget)
    {
        imgWidget.attr("src", verifycodeFail);
        imgWidget.show();
    }

    function clearVerifycodeImg(imgWidget)
    {
        if (imgWidget.src !== "")
        {
            imgWidget.hide();
        }
    }

    function validateVerifyCode(verifycode, imgWidget)
    {
        // 过滤掉ios中文输入法下可能出现的特殊空格字符
        verifycode = verifycode.replace(/\u2006/g, "");
        if (verifycode === "" || verifycode === undefined) {
            clearVerifycodeImg(imgWidget);
            return false;
        }
        if (verifycode.length < 4) {
            changeToFailImg(imgWidget);
            return false;
        } else {
            return true;
        }
    }

    function substrVerifyCode(verifycode)
    {
        if (verifycode === "" && verifycode === undefined)
        {
            return "";
        }
        if (verifycode.length > 4)
        {
            return verifycode.substring(0, 4);
        }
        else
        {
            return verifycode;
        }
    }

    function checkVerifyCode(imgWidget, verifycode, index, callback, iamHttpService, i18n)
    {
        iamHttpService.post({
            url:validUrl,
            params:{
                verifycode: verifycode,
                index: index
            }
        }).then(function(data) {
                if (data === "success") {
                    changeToSuccessImg(imgWidget);
                    callback(true);
                }else {
                    changeToFailImg(imgWidget);
                    callback(false);
                }
            }, function() {
                if (i18n) {
                    // 接口异常 提示用户刷新页面
                    angular.element("#serverError").removeClass("ng-hide");
                    angular.element("#serverError").css("display", "block");
                    angular.element("#serverError>span:first").text(i18n("systemException"));

                    setTimeout(function(){
                        angular.element("#serverError").addClass("ng-hide");
                        angular.element("#serverError").css("display", "none");
                        angular.element("#serverError>span:first").text("");
                    }, 10000);
                }
            }
        );
    }

    function preValidVerifyCode(imgWidget, verifycode, index, callback, iamHttpService, i18n)
    {
        if (validateVerifyCode(verifycode, imgWidget) === false)
        {
            return false;
        }
        checkVerifyCode(imgWidget, substrVerifyCode(verifycode), index, callback, iamHttpService, i18n);
    }

    return {
        preValidVerifyCode: preValidVerifyCode
    };
});


// WEBPACK FOOTER //
// ./public/base/utils/preVerifycodeUtil.js